var map = {
	"./1.jpg": 1005,
	"./2.jpg": 1006,
	"./3.jpg": 1007,
	"./4.jpg": 1008,
	"./5.jpg": 1009,
	"./AvatarMaestra.jpg": 89,
	"./AvatarMaestro.jpg": 88,
	"./Female.jpg": 347,
	"./Female2.jpg": 266,
	"./Male.jpg": 346,
	"./Male2.jpg": 265
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 550;